export default __webpack_public_path__ + "static/media/metamask_icon.17050ef6.png";